import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const DEFAULT_TITLE = 'Agastya Agro Limited';
const DEFAULT_DESCRIPTION =
  'Agastya Agro Limited provides high-quality agricultural solutions including insecticides, fungicides, herbicides, and plant growth products for Indian farmers.';
const TITLE_MAX_LENGTH = 60;
const DESCRIPTION_MAX_LENGTH = 160;

const truncateForMeta = (value, maxLength) => {
  if (!value || typeof value !== 'string') return '';
  if (value.length <= maxLength) return value;
  return `${value.slice(0, maxLength - 1).trimEnd()}...`;
};

const getBaseUrl = () => {
  const fromEnv = process.env.REACT_APP_SITE_URL;
  if (fromEnv && fromEnv.trim()) {
    return fromEnv.replace(/\/+$/, '');
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/+$/, '');
  }
  return '';
};

const Seo = ({
  title,
  description,
  path,
  image,
  type = 'website',
  noIndex = false,
}) => {
  const location = useLocation();
  const baseUrl = getBaseUrl();
  const currentPath = path || `${location.pathname}${location.search}`;
  const canonicalUrl = baseUrl ? `${baseUrl}${currentPath}` : currentPath;
  const metaTitle = truncateForMeta(title || DEFAULT_TITLE, TITLE_MAX_LENGTH);
  const metaDescription = truncateForMeta(description || DEFAULT_DESCRIPTION, DESCRIPTION_MAX_LENGTH);
  const metaImage = image || (baseUrl ? `${baseUrl}/meta-logo.jpg` : '/meta-logo.jpg');

  return (
    <Helmet>
      <title>{metaTitle}</title>
      <meta name="title" content={metaTitle} />
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content="Smart Farming, Agriculture App, Crop Advisory, Soil Testing, Precision Agriculture, Best Agri Solution, Kisan App"  />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:site_name" content="Agastya Agro Limited" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />

      {noIndex ? (
        <meta name="robots" content="noindex,nofollow" />
      ) : (
        <meta name="robots" content="index,follow" />
      )}
    </Helmet>
  );
};

export default Seo;
